import type { Person } from '@tixa/schema'

export const createPerson = (email: string): Person => {
  return {
    '@id': email,
    '@type': 'Person',
    email: email,
    address: {
      '@type': 'Address',
      addressCountry: '',
      addressLocality: '',
      addressRegion: '',
      postalCode: '',
      streetAddress: '',
      countryCode: '',
    },
    name: '',
    telephone: '',
  }
}
